import { writable } from 'svelte/store';

export const isVertical = writable(false);